import {Validators} from '@angular/forms';
import {
  CustomValidator, fmcValidator,
  noWhitespaceValidator
} from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';
import {defaultFieldConfig} from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';

export class TrustDetailsModel {
  trustList = {
    value: [],
    validation: Validators.compose([])
  };
}


export class IndividualTrustModel {
  partyId = {
    value: null,
    validation: Validators.compose([])
  };
  partyRoleId = {
    value: null,
    validation: Validators.compose([])
  };
  trustName = {
    value: null,
    validation: Validators.compose([
      noWhitespaceValidator,
      Validators.required
    ])
  };
  trustABN = {
    value: null,
    validationAsync: [fmcValidator('abn')]
  };
  trustNoABN = {
    value: false,
    validation: Validators.compose([])
  };
  // trustACN = {
  //     value: null,
  //     validation: Validators.compose([])
  // };
  trustType = {
    value: null,
    validation: Validators.compose([])
  };
  trustContactName = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      CustomValidator.nameValidator(defaultFieldConfig.fullName)
    ])
  };
  trustContactPosition = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  trustContactMobile = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  trustContactEmail = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.email
    ])
  };

  // trustTradingAddress = new AddressModel();
  // trustPostalAddress = new AddressModel();
  tradingAddress = {
    value: null,
    validation: Validators.compose([])
  };
  postalAddress = {
    value: null,
    validation: Validators.compose([])
  };
  postalAddressAsTrading = {
    value: true,
    validation: Validators.compose([])
  };
  postSettlementAddress = {
    value: true,
    validation: Validators.compose([])
  };
  postSettlementAddressAsTrading = {
    value: true,
    validation: Validators.compose([])
  };
  contactDetailsAsEntity = {
    value: null,
    validation: Validators.compose([])
  };
  ext = {
    value: null,
    validation: Validators.compose([])
  };
  contactSelected = {
    value: null,
    validation: Validators.compose([])
  };
}
